import {paEnv} from './paEnv';
import {paRoute} from './paRoute';

export const paIframeChild = {
    isIframe: false,
    iframeOptions: null,
    libSource: '',
    init() {
        this.detectIframe();
        if (!paEnv.isIE9Nightmare() && this.isIframe) {
            this.addEventListener();
            this.childLoaded();
            this.loadPartially();
        }
    },
    detectIframe() {
        try {
            this.isIframe = window.self !== window.top;
        } catch (e) {
            this.isIframe = true;
        }
    },
    addEventListener() {
        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent',
            eventer = window[eventMethod],
            messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message';
        eventer(messageEvent, function (e) {
            var key = e.message ? 'message' : 'data',
                data = e[key];

            if (data.task == 'data') {
                if (data.data) {
                    paCore.data = data.data;
                }
                paIframeChild.iframeOptions = data;
                paIframeChild.libDomHandler = data.libDomHandler;
                paIframeChild.libSource = data.libSource;

                // paApp.init();
            }
        }, false);
    },
    execute(methodName) {
        parent.postMessage({id: paRoute.id, task: methodName}, '*');
    },
    sendHeight(height) {
        var $body = document.getElementsByTagName('BODY')[0],
            height = height || $body.offsetHeight;

        parent.postMessage({id: paRoute.id, task: 'changeHeight', height: height + 15}, '*');
    },
    childLoaded() {
        this.execute('childLoaded');
    },
    disableLoading() {
        this.execute('disableLoading');
    },
    allIsDone() {
        this.disableLoading();
        this.sendHeight();
    },
    loadPartially: function () {
        let iframeTargetId = paRoute.id,
            $iframeTarget = window.document.querySelector('#' + iframeTargetId),
            $wrapper = window.document.querySelector('body');

        if (!$wrapper) {
            $wrapper = window.document.querySelector('body');
        }

        if (typeof iframeTargetId != 'undefined' && $iframeTarget && $wrapper != $iframeTarget) {
            // while ($wrapper.firstChild) {
            //     $wrapper.removeChild($wrapper.firstChild);
            // }

            for (let i = 1; i < $wrapper.childNodes.length; i++) {
                let $el = $wrapper.childNodes[i];
                if ($el != $iframeTarget && typeof $el.style != 'undefined' && $el.tagName != 'template' && $el.offsetParent != null) {
                    $el.style.display = 'none';
                }
            }
            $wrapper.appendChild($iframeTarget);
        }
    }

};


// WEBPACK FOOTER //
// ./src/js/framework/paIframeChild.js